<template>
    <span>
        <span v-if="! t9n">{{ val }}</span>
        <span v-else
            :class="[trStatusClass]" @click.stop="$emit ('edit-tr', {tid, trackerIdx})"
            :id="elementId"
            >{{ displayText }}<i class="mdi mdi-help-circle"></i>
        </span>
    </span>
</template>

<script>
import { mapState }         from 'vuex'

export default {
    name: "TrText",
    props: {
        val:    { type: [String, Array], required: false, default: "XXX Not Value specified XXX"},
        t9n:    { type: Boolean, default: false},
        tracker: Array
    },
    data () { return {trackerIdx: 0, isActive: false}},
    computed : {
        ...mapState ("translation", {
            targetLang:  state => state.targetLang,
            sourceLang:  state => state.sourceLang,
            languages:   state => state.languages,
        }),
        tid () {
            return this.val [0] [0]
        },
        elementId () {
            return "tracker" + this.trackerIdx
        },
        trText () {
            if (this.targetLang) {
                const trLangs = this.languages [this.targetLang]
                if (trLangs !== undefined) {
                    return trLangs [1] [this.tid]
                }
            }
            return undefined
        },
        displayText () {
            const tr = this.trText
            if (tr !== undefined) return tr
            return this.languages [this.sourceLang] [1] [this.tid]
        },
        trStatusClass () {
            if (this.isActive) return "tr-is-active"
            return this.translated ? "" : "tr-untranslated"
        },
        translated () {
            return this.trText !== undefined
        }
    },
    watch: {
        isActive (val) {
            if (val) this.$emit ("tr-unit-activated", this)
        }
    },
    mounted () {
        if (this.t9n) {
            this.trackerIdx = this.tracker.length
            this.tracker.push (this)
        }
    }

}
</script>

<style>
    span {
        cursor: pointer;
        padding: 0 0.5em;
    }
    .tr-is-active {
        border-bottom: 2px dashed blue;
    }
    .tr-untranslated {
        border-bottom: 2px solid red;
    }

</style>